import { Routes } from '@angular/router';

import { authCanMatch } from '@core/guards/auth.can-match';
import { guestCanMatch } from '@core/guards/guest.can-match';

export const routes: Routes = [
  {
    path: 'login',
    canMatch: [guestCanMatch],
    loadChildren: () => import('@features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'forgot-password',
    canMatch: [guestCanMatch],
    loadComponent: () =>
      import('@features/auth/forgot-password/forgot-password-page.component').then(
        (m) => m.ForgotPasswordPageComponent,
      ),
  },
  {
    path: 'terms-of-service',
    loadComponent: () =>
      import('@features/auth/legal/terms-of-service-page/terms-of-service-page.component').then(
        (m) => m.TermsOfServicePageComponent,
      ),
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('@features/auth/legal/privacy-policy-page/privacy-policy-page.component').then(
        (m) => m.PrivacyPolicyPageComponent,
      ),
  },
  {
    path: 'ui-demo',
    loadChildren: () => import('@features/ui-demo/ui-demo.routes').then((m) => m.UI_DEMO_ROUTES),
  },
  {
    path: 'remmi',
    loadChildren: () => import('@features/home/home.routes').then((m) => m.HOME_ROUTES),
  },
  {
    path: '',
    canMatch: [authCanMatch],
    loadChildren: () =>
      import('@features/protected/protected.routes').then((m) => m.PROTECTED_ROUTES),
  },
];
